import { GraphQLError } from 'graphql';
import { graphql } from 'msw';

import { SocialSignInGoogleMutation } from '../AuthModal/section/SignIn/queries/googleSignIn.generated';
import { generateUserWithTrackedPropertiesHandler } from './user';

export const generateGoogleHandler = (
    response: SocialSignInGoogleMutation['socialSignInGoogle']
) => {
    return graphql.mutation<SocialSignInGoogleMutation>(
        'socialSignInGoogle',
        (_, res, ctx) => {
            return res(ctx.data({ socialSignInGoogle: response }));
        }
    );
};

export const generateGoogleErrorHandler = (
    errorMessage: GraphQLError['message']
) => {
    const graphqlError = new GraphQLError(errorMessage);

    return graphql.mutation<SocialSignInGoogleMutation>(
        'socialSignInGoogle',
        (_, res, ctx) => {
            return res(ctx.errors([graphqlError]));
        }
    );
};

export const defaultGoogleHandler = generateGoogleHandler({
    success: true
});

export const googleFailHandler = generateGoogleHandler({
    success: false
});

export const googleServerErrorHandler =
    generateGoogleErrorHandler('<Error message>');

export const defaultGoogleUserHandler =
    generateUserWithTrackedPropertiesHandler({
        loggedIn: true,
        name: '<test-name>',
        email: '<test-email>',
        status: 'valid',
        senderPropertyStatus: '',
        userId: 32503316,
        userUuid: '<user-id>',
        creationDate: '2020-01-26 11:34:01',
        brandPrimary: 'zoopla',
        registrationSources: ['google'],
        registered: true,
        trackedProperties: {
            items: [],
            total: 0
        }
    });

export const googleNewUserHandler = generateUserWithTrackedPropertiesHandler({
    loggedIn: true,
    name: '<test-name>',
    email: '<test-email>',
    status: 'valid',
    senderPropertyStatus: '',
    userId: 32503316,
    userUuid: '<user-id>',
    creationDate: '2020-01-26 11:34:01',
    brandPrimary: 'zoopla',
    registrationSources: ['google'],
    registered: false,
    trackedProperties: {
        items: [],
        total: 0
    }
});
